<template>
    <div v-show="block.display" class="home-block" v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-html="block.title" :style="{marginLeft: '12px'}"></h2>
        <div class="home-block-content">
            <div class="categories-content" ref="block" >
                <div class="slider-margin">&nbsp;</div>
                <template v-if="block.isLoading">
                    <div v-for="n in roundNumberProducts" class="category-item" :key="n" :style="{width: `${catWidth}px`,height: `${catWidth / 2}px`}">
                        <div class="category-item-border w-100 h-100 skeleton-box"></div>
                    </div>
                </template> 
                <div v-for="cat in block.dataContent" :key="cat.id" class="category-item" :style="{width: `${catWidth}px`, minHeight: `${catWidth / 2}px`}">
                    <div class="category-item-border w-100 h-100" @click="gotoCategory(cat.url)" :style="{backgroundColor: cat.color ? cat.color : null}">
                        <a :href="cat.url" class="w-100 h-100 slider-item-href">&nbsp;</a>
                        <div class="category-item-content h-100 w-100 d-flex justify-content-center align-items-center">
                            <span class="category-label">{{cat.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="slider-margin">&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadImage from '@/components/ProductPage/Desktop/LoadImage';
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
export default {
    components:{
        LoadImage
    },
    props:{
        block:{
            type: HomeBlock
        },
        margin:{
            type: Number,
            default: 3
        }
    },
    computed: {
        roundNumberProducts(){
            return Math.floor(this.block.numberItens);
        }
    },
    data(){
        return{
            catWidth: 0
        }
    },
    mounted() {
        this.resize();
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.block.load();
            }
        },
        gotoCategory(url){
            homeUtils.gotoUrl(url,this.block);
        },
        resize(){
            let viewWidth    = homeUtils.getViewPortWidth(true);
            let marWidth     = Math.round(viewWidth * (this.margin * 2 / 100));
            let cWidth       = (viewWidth - marWidth) / this.block.numberItens;
            this.catWidth    = Math.round(cWidth);
        }
    }
}
</script>